module.exports = __webpack_public_path__ + "static/media/publicRoomIcon.167a04a5.svg";